module.exports = __webpack_public_path__ + "static/media/city-hero.07f7d759.jpg";